<template>
    <layout title="Balance Activity">
        <monthly-statement-activity :data-obj="dataObj"></monthly-statement-activity>
    </layout>
</template>

<script>

import Layout from "@/Shared/Layout";
import MonthlyStatementActivity from "../../Components/Statements/MonthlyStatementActivity";

export default {
    components: {MonthlyStatementActivity, Layout},
    props: {
        dataObj: {
            type: Object,
        },
    },
}
</script>
